import { DatePipe, NgForOf, NgIf, NgClass, CommonModule } from '@angular/common';
import { AfterViewInit, Component, OnChanges, OnInit, SimpleChanges,    TemplateRef,    ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { MatCard, MatCardContent, MatCardHeader, MatCardModule, MatCardSubtitle, MatCardTitle } from '@angular/material/card';
import { MatCheckbox, MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule, MatOption } from '@angular/material/core';
import { MatDatepicker, MatDatepickerInput, MatDatepickerModule, MatDatepickerToggle } from '@angular/material/datepicker';
import { MatError, MatFormField, MatFormFieldModule, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInput, MatInputModule } from '@angular/material/input';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { MatSort, MatSortHeader, MatSortModule } from '@angular/material/sort';
import { MatCell, MatCellDef, MatColumnDef, MatHeaderCell, MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef, MatTable, MatHeaderCellDef, MatNoDataRow, MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { MatTooltip, MatTooltipModule } from '@angular/material/tooltip';
import { SafePipe } from '../../../safe.pipe';
import { HandleErrorsService } from '../../../services/handle-erros/handle.errors.service';
import { RapportService } from '../../../services/rapport-service/rapport.service';
import { DialogService } from '../../_modal/dialog.service';
import { Endpoints } from '../../endpoints';
import { FichePaillasse } from '../../_models/FichePaillasseDTO';
import { AnalyseInstrumentaleDTO, BatchAnalytique, FichePaillasseService, SaveStepDTO } from '../../../services/fiche-paillasse-service/fiche-paillasse.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MatDivider } from "@angular/material/divider";
import { forkJoin } from 'rxjs';
import { MatProgressBar } from "@angular/material/progress-bar";


@Component({
  selector: 'app-fiche-paillasse',
  standalone: true,
  templateUrl: './fiche-paillasse.component.html',
  styleUrls: ['./fiche-paillasse.component.scss'],
  providers: [DialogService, SafePipe, HandleErrorsService, RapportService, Endpoints],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule, // <--- indispensable pour mat-option + ngValue
    MatInputModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatIconModule,
    MatTooltipModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    NgIf,
    NgForOf,
    MatProgressBar
]
})

export class FichePaillasseComponent implements OnInit{

  typeInstruments = ['GCMSMS', 'LCMSMS'];
  methodesInstrumentales: any[] = [];
  batches: any[] = [];
  batchesByLine: BatchAnalytique[][] = [];
  ngOnInit(): void {
   this.getAllFiches()
   this.initForm()
  }

  constructor(private fichePaillasseService: FichePaillasseService,
    private fb: FormBuilder,
    private modalService: NgbModal,private dialogService: DialogService
) {         this.initializeForm();
}
  @ViewChild('editModal') editModal: TemplateRef<any>;
  fiches: FichePaillasse[] = [];
  loadingFiches: boolean = false;
  dataSource!: MatTableDataSource<FichePaillasse>;
  displayedColumns: string[] = ['select', 'sampleId', 'code','creationDate', 'steps','progressionTexte', 'statut','action'];
  loadingTable = false;
  uniteOptions: string[] = ['g', 'mg', 'kg', 'µg', 'L', 'mL', 'µL', '%', 'mg/L', 'ppm', 'ppb', '°C', 'pH', 'aw'];
  showFicheForm = false;
  selectedFiche: any = null;

  
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
    form: FormGroup;
  initializeForm() {
    this.form = this.fb.group({
      fichePaillasseId: [null],
      echantillonId: [null, Validators.required],
      typeInstrument: [null, Validators.required],
      methodeInstrumentaleId: [null, Validators.required],
      batchId: [null],
      batchName: [null],
      dateCreationBatch: [null],
      dateAnalyse: [null, Validators.required],
      emplacement:[null,Validators.required],
      statut: ['PLANIFIEE', Validators.required],
      commentaire: [''],
      analyses: this.fb.array([])

    });
  }

// Arrays utilisés dans le HTML
  methodesDisponibles: any[][] = [];
  batchesDisponibles: any[][] = [];
  ficheForm!: FormGroup;

    initForm() {
    this.ficheForm = this.fb.group({
      analysesInstrumentales: this.fb.array([])
    });
  }
   get analysesInstrumentales(): FormArray {
    return this.ficheForm.get('analysesInstrumentales') as FormArray;
  }

  // ===== CREATE FORM =====
  createAnalyseInstrumentaleForm(): FormGroup {
    return this.fb.group({
      typeInstrument: [null, Validators.required],
      methodeInstrumentale: [null, Validators.required],
      batch: [null],
      dateAnalyse: [null],
      emplacement: [null],
      batchName: [null],        // NOM DU FICHIER
      dateCreationBatch: [null],
      statut: ['PLANIFIEE']
    });
  }

  // ===== ADD =====
  addAnalyseInstrumentale() {
    this.analysesInstrumentales.push(this.createAnalyseInstrumentaleForm());
    this.methodesDisponibles.push([]);
    this.batchesDisponibles.push([]);
  }

  // ===== REMOVE =====
  removeAnalyse(index: number) {
    this.analysesInstrumentales.removeAt(index);
    this.methodesDisponibles.splice(index, 1);
    this.batchesDisponibles.splice(index, 1);
  }

  // ===== CHANGE TYPE =====
onTypeInstrumentChange(index: number) {
  console.log('==============================');
  console.log('🔁 onTypeInstrumentChange déclenchée');
  console.log('Index analyse instrumentale :', index);

  const aiForm = this.analysesInstrumentales.at(index) as FormGroup;

  if (!aiForm) {
    console.error('❌ FormGroup introuvable pour index', index);
    return;
  }

  const type = aiForm.get('typeInstrument')?.value;
  console.log('🎯 Type instrument sélectionné :', type);

  if (!type) {
    console.warn('⚠️ Aucun type sélectionné, reset des listes');
    this.methodesDisponibles[index] = [];
    this.batchesDisponibles[index] = [];
    return;
  }

  // ===============================
  // 🔹 Chargement méthodes instrumentales
  // ===============================
  console.log('📡 Appel service getByType pour méthodes instrumentales...');
  this.fichePaillasseService.getMethodesInstrumentales(type).subscribe({
    next: (methodes) => {
      console.log('✅ Méthodes instrumentales reçues :', methodes);
      this.methodesDisponibles[index] = methodes || [];
    },
    error: (err) => {
      console.error('❌ Erreur chargement méthodes instrumentales', err);
      this.methodesDisponibles[index] = [];
    }
  });

  // ===============================
  // 🔹 Chargement batches ouverts
  // ===============================
  console.log('📡 Appel service getOpenBatches pour batches analytiques...');
  this.fichePaillasseService.getBatches(type).subscribe({
    next: (batches) => {
      console.log('✅ Batches reçus :', batches);
      this.batchesDisponibles[index] = batches || [];
    },
    error: (err) => {
      console.error('❌ Erreur chargement batches', err);
      this.batchesDisponibles[index] = [];
    }
  });

  // ===============================
  // 🔹 Reset champs dépendants
  // ===============================
  console.log('♻️ Reset méthode et batch sélectionnés');
  aiForm.patchValue({
    methodeInstrumentale: null,
    batch: null
  });

  console.log('==============================');
}


  // ===== MOCK DATA (temporaire) =====
  allMethodes: any[] = [];
  allBatches: any[] = [];

  // 📌 Pour la méthode instrumentale
onFileSelectedMethod(event: any, index: number) {
  const file: File = event.target.files[0];
  if (file) {
    console.log(`[File Upload][Method][${index}] Nom :`, file.name);
    console.log(`[File Upload][Method][${index}] Taille :`, file.size);
    console.log(`[File Upload][Method][${index}] Type :`, file.type);
    console.log(`[File Upload][Method][${index}] Date dernière modification :`, new Date(file.lastModified));

    const control = this.analysesInstrumentales.at(index).get('emplacement');
    if (control) {
      control.setValue(file.name); // ou file.path si tu veux chemin complet (mais navigateur souvent interdit)
    }

    // si tu veux stocker la date de création du fichier local
    const dateControl = this.analysesInstrumentales.at(index).get('dateCreationMethod');
    if (dateControl) {
      dateControl.setValue(new Date(file.lastModified)); 
    }
  }
}

// 📌 Pour le batch analytique
onFileSelectedBatch(event: any, index: number) {
  const file: File = event.target.files[0];
  if (file) {
    console.log(`[File Upload][Batch][${index}] Nom :`, file.name);
    console.log(`[File Upload][Batch][${index}] Taille :`, file.size);
    console.log(`[File Upload][Batch][${index}] Type :`, file.type);
    console.log(`[File Upload][Batch][${index}] Date dernière modification :`, new Date(file.lastModified));

    const batchControl = this.analysesInstrumentales.at(index).get('batch');
    if (batchControl) {
      batchControl.patchValue({
        batchName: file.name,
        dateCreationBatch: new Date(file.lastModified)
      });
    }
  }
}

openEditModal(fiche: FichePaillasse) {
  // 1️⃣ Réinitialiser le formulaire avant d'ouvrir
  this.resetFicheForm();

  // 2️⃣ Assigner la fiche sélectionnée
  this.selectedFiche = { ...fiche }; // faire une copie pour éviter les références
  console.log('Fiche sélectionnée :', this.selectedFiche);

  // 3️⃣ FORMAT DATE POUR datetime-local
  this.selectedFiche.steps = this.selectedFiche.steps.map((step: { dateRealisation: string; }) => {
    if (step.dateRealisation) {
      step.dateRealisation = this.formatForDatetimeLocal(step.dateRealisation);
    }
    return step;
  });

  // 4️⃣ Pré-remplir le FormArray avec les analyses existantes (si besoin)
  if (this.selectedFiche.analysesInstrumentales) {
    this.selectedFiche.analysesInstrumentales.forEach((ai: { typeInstrument: any; methodeInstrumentale: any; dateAnalyse: any; emplacement: any; batchName: any; dateCreationBatch: any; statut: any; commentaire: any; }) => {
      this.analysesInstrumentales.push(this.fb.group({
        typeInstrument: [ai.typeInstrument || null],
        methodeInstrumentale: [ai.methodeInstrumentale || null],
        dateAnalyse: [ai.dateAnalyse || null],
        emplacement: [ai.emplacement || null],
        batchName: [ai.batchName || null],
        dateCreationBatch: [ai.dateCreationBatch || null],
        statut: [ai.statut || 'PLANIFIEE'],
        commentaire: [ai.commentaire || null],
        fileUpload: [null] // toujours null pour le nouveau chargement
      }));
    });
  }

  // 5️⃣ Ouvrir le modal avec clic en dehors pour fermer
  this.modalRef = this.modalService.open(this.editModal, {
    size: 'xl',
    backdrop: true, // clic en dehors ferme le modal
    keyboard: true  // Échap ferme le modal
  });

  // 6️⃣ Réinitialiser formulaire si modal fermé
  this.modalRef.result.finally(() => {
    this.resetFicheForm();
    this.selectedFiche = null;
  });
}

// --------------------
saveAnalysesInstrumentales() {
  const analyses = this.analysesInstrumentales.value.map((ai: any) => {
    return {
      fichePaillasseId: this.selectedFiche.id,
      echantillonId: this.selectedFiche.sampleId,
      typeInstrument: ai.typeInstrument,
      methodeInstrumentaleId: ai.methodeInstrumentale?.id,
      batchId: ai.batch?.id,
      dateAnalyse: ai.dateAnalyse,
      emplacement: ai.emplacement,
      batchName: ai.batchName,        // NOM DU FICHIER
      dateCreationBatch: ai.dateCreationBatch,
      statut: ai.statut,
      commentaire: ai.commentaire || null
    };
  });

  console.log('Analyses préparées pour backend :', analyses);

  const requests = analyses.map((dto: AnalyseInstrumentaleDTO) =>
    this.fichePaillasseService.addAnalyseInstrumentale(dto)
  );

  forkJoin(requests).subscribe({
    next: (results: any) => {
      console.log('Toutes les analyses enregistrées :', results);

      // 1️⃣ Vider le FormArray
      this.analysesInstrumentales.clear();

      // 2️⃣ Fermer le modal
      if (this.modalRef) {
        this.modalRef.close();
      }

      // 3️⃣ Réinitialiser le formulaire
      this.resetFicheForm();
      this.selectedFiche = null;

      // 4️⃣ Message de succès (création + génération résultats)
      this.dialogService.openSuccessDialog(
        'Les analyses instrumentales ont été enregistrées avec succès et les résultats d’analyse ont été générés automatiquement.'
      );

      // 5️⃣ Rafraîchir la liste des fiches
      this.getAllFiches();
    },
    error: (err: any) => {
      console.error('Erreur lors de l’enregistrement des analyses :', err);
      this.dialogService.openDangerAlert('Impossible d’enregistrer certaines analyses. Veuillez réessayer.');
    }
  });
}

// --------------------
// Méthode utilitaire pour réinitialiser le formulaire
resetFicheForm() {
  this.ficheForm = this.fb.group({
    analysesInstrumentales: this.fb.array([])
  });
}



    dataSource1: MatTableDataSource<AnalyseInstrumentaleDTO> = new MatTableDataSource<AnalyseInstrumentaleDTO>();
    
    ngOnChanges(changes: SimpleChanges) {
            if (changes['dataSource1']) {
                this.initializeForm();
            }
        }
  getAllFiches(): void {
    this.loadingTable = true;
    this.fichePaillasseService.getAllFiches().subscribe({
      next: (res) => {
        console.log('✅ Fiches récupérées :', res);
        this.fiches = res;
        this.dataSource = new MatTableDataSource(this.fiches);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.loadingTable = false;
      },
      error: (err) => {
        console.error('Erreur chargement fiches', err);
        this.loadingTable = false;
      }
    });
  }

  

    applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  // Exemple d'action
openFiche(fiche: any) {
  this.selectedFiche = fiche;
  this.form.patchValue({
    fichePaillasseId: fiche.id,
    echantillonId: fiche.sampleId
  });
  this.showFicheForm = true;
}

saveAnalyse() {
  console.log('saveAnalyse() appelée');

  this.form.patchValue({
    fichePaillasseId: Number(this.selectedFiche.id),
    echantillonId: Number(this.selectedFiche.sampleId),
    methodeInstrumentaleId: Number(this.form.get('methodeInstrumentaleId')?.value),
    batchId: this.form.get('batchId')?.value
      ? Number(this.form.get('batchId')?.value)
      : null
  });

  if (this.form.invalid) {
    console.warn('Formulaire invalide !', this.form.value);
    return;
  }

  const payload = this.form.value;

  console.log(
    'Payload final envoyé au backend :',
    payload,
    'type methodeInstrumentaleId =',
    typeof payload.methodeInstrumentaleId
  );

  this.fichePaillasseService.addAnalyseInstrumentale(payload).subscribe({
    next: (res) => {
      console.log('Réponse du backend :', res);
      this.dialogService.openSuccessDialog(
        'Analyse instrumentale ajoutée avec succès'
      );
      this.modalRef.close();
    },
    error: (err) => {
      console.error('Erreur lors de l\'appel au backend :', err);
      this.dialogService.openDangerAlert(
        'Erreur lors de l\'ajout de l\'analyse'
      );
    }
  });
}
get analyses(): FormArray {
  return this.form.get('analyses') as FormArray;
}

// Ajouter une ligne
addAnalyse() {
  // Crée un nouveau FormGroup pour une ligne d'analyse
  this.analyses.push(this.fb.group({
    typeInstrument: [null, Validators.required],
    methodeInstrumentaleId: [null, Validators.required],
    batchId: [null]
  }));

  // Ajoute une entrée vide dans le tableau batchesByLine pour cette ligne
  this.batchesByLine.push([]);

  const index = this.analyses.length - 1;

  // Mettre à jour le tableau de batches filtrés lorsque la méthode change
  this.analyses.at(index).get('methodeInstrumentaleId')?.valueChanges.subscribe(methodId => {
    this.batchesByLine[index] = methodId
      ? this.batches.filter(b => b.methodeInstrumentale.id === methodId)
      : [];
    // Reset batch sélectionné si méthode change
    this.analyses.at(index).get('batchId')?.setValue(null);
  });
}

// Supprimer une ligne
  modalRef!: NgbModalRef;

formatForDatetimeLocal(date: string): string {
  const d = new Date(date);

  const pad = (n: number) => n.toString().padStart(2, '0');

  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}


  onRealiseChange(step: any) {
  if (!step.realise) {
    step.valeurMesuree = null;
    step.unite = null;
    step.dateRealisation = null;
    step.status = null;
    step.commentaire = null;
  }
}


  saveFiche(fiche: FichePaillasse): void {
    this.fichePaillasseService.saveFicheValues(fiche).subscribe({
      next: (updated) => {
        console.log('Fiche sauvegardée:', updated);
        this.dialogService.openSuccessDialog("Fiche enregistrée avec succès");
      },
      error: (err) => {
        console.error('Erreur sauvegarde fiche:', err);
        fiche.open = false;
      }
    });
  }

saveStep(step: any): void {
  if (!this.selectedFiche || !step) return;

  const dto: SaveStepDTO = {
    ficheId: this.selectedFiche.id,
    stepId: step.id,
    realise: !!step.realise,
    valeurMesuree: step.valeurMesuree ? +step.valeurMesuree : undefined,
    unite: step.unite,
    dateRealisation: step.dateRealisation,
    statut: step.statut,
    commentaire: step.commentaire
  };

  // 🔹 Console pour debug
  console.log('=== Envoi de l\'étape au backend ===');
  console.log('Fiche ID:', dto.ficheId);
  console.log('Step ID:', dto.stepId);
  console.log('Réalisé:', dto.realise);
  console.log('Valeur mesurée:', dto.valeurMesuree);
  console.log('Unité:', dto.unite);
  console.log('Date réalisation:', dto.dateRealisation);
  console.log('Statut:', dto.statut);
  console.log('Commentaire:', dto.commentaire);
  console.log('DTO complet:', dto);
  console.log('====================================');

  this.fichePaillasseService.saveStep(dto).subscribe({
    next: () => {
      console.log('✅ Step sauvegardé avec succès:', step.titre);
      this.dialogService.openSuccessDialog(`Étape "${step.titre}" enregistrée.`);
      this.getAllFiches();
    },
    error: (err) => {
      console.error('❌ Erreur sauvegarde step', step.titre, err);
    }
  });
}

   isAllFichePaillasseSelected: boolean = false;
   selectedFichePaillasse: Set<FichePaillasse> = new Set<FichePaillasse>(); 

onFileSelected(event: any, index: number) {
  const file: File = event.target.files[0];
  if (!file) {
    console.log(`[File Upload][${index}] Aucun fichier sélectionné`);
    return;
  }

  console.log(`[File Upload][${index}] Fichier sélectionné :`);
  console.log(`- Nom du fichier : ${file.name}`);
  console.log(`- Taille : ${file.size} bytes`);
  console.log(`- Type MIME : ${file.type}`);
  console.log(`- Date dernière modification (lastModified) : ${new Date(file.lastModified)}`);

  const formArray = this.analysesInstrumentales;
  const control = formArray.at(index);

  // Patcher le nom du batch
  control.patchValue({ batchName: file.name });
  console.log(`[FormArray][${index}] batchName mis à jour : ${control.value.batchName}`);

  // Date de dernière modification convertie en heure locale pour datetime-local
  const localDate = new Date(file.lastModified);
  const isoLocal = localDate.getFullYear() + '-' +
    String(localDate.getMonth() + 1).padStart(2, '0') + '-' +
    String(localDate.getDate()).padStart(2, '0') + 'T' +
    String(localDate.getHours()).padStart(2, '0') + ':' +
    String(localDate.getMinutes()).padStart(2, '0');

  control.patchValue({ dateCreationBatch: isoLocal });
  console.log(`[FormArray][${index}] dateCreationBatch mis à jour (locale) : ${control.value.dateCreationBatch}`);

  // Stocker le fichier pour l’upload
  control.patchValue({ fileUpload: file });
  console.log(`[FormArray][${index}] fichier prêt pour upload`, control.value.fileUpload);

  // Vérification finale
  console.log(`[FormArray][${index}] Valeur actuelle du contrôle :`, control.value);
}


  handleSelectAll() {
          this.isAllFichePaillasseSelected = !this.isAllFichePaillasseSelected;
          this.selectedFichePaillasse = this.isAllFichePaillasseSelected
              ? new Set<FichePaillasse>(this.dataSource.filteredData)
              : new Set<FichePaillasse>();
      }
  
    handleSelection(fichePaillasse: FichePaillasse) {
          if (this.selectedFichePaillasse.has(fichePaillasse)) {
              this.selectedFichePaillasse.delete(fichePaillasse);  
              console.log(`Bons de Commande avec ID ${fichePaillasse.id} a été désélectionné`);
          } else {
              this.selectedFichePaillasse.add(fichePaillasse); 
              console.log(`Bons de Commande  avec ID ${fichePaillasse.id} a été sélectionné`);
          }
      
          console.log('Rapports sélectionnés:', Array.from(this.selectedFichePaillasse).map(item => item.id));
      }

    toggleFiche(ficheId: number) {
  const fiche = this.fiches.find(f => f.id === ficheId);
  if (fiche) {
    fiche.open = !fiche.open; // propriété pour afficher/masquer l'édition
  }
}


analyse: any = {};
typeInstrumentOptions = ['GCMSMS', 'LCMSMS'];
statutOptions = ['PLANIFIEE', 'REALISEE', 'VALIDEE'];




}


